<template>
  <v-app>
    <Topbar />
    <!--Declaration of all Tabs -->
    <v-tabs v-model="activeTab" height="45px">
      <v-tab
        v-for="tab of tabs"
        :key="tab.id"
        :to="tab.route"
        exact
        class="font-weight-bold subtitle-2 black--text"
      >{{tab.name}}</v-tab>

      <v-tab-item v-for="tab of tabs" :key="tab.id" :value="tab.route">
        <router-view></router-view>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>

<script>
import Topbar from "@/components/Topbar.vue";
export default {
  components: { Topbar },

  props: ["id"],
  data() {
    return {
      activeTab: `/Main/${this.id}`,
      tabs: [
        {
          id: 1,
          name: "Manage Surveys",
          route: `/Main/${this.id}/ManageSurveys`
        },
        {
          id: 2,
          name: "Register Surveyors",
          route: `/Main/${this.id}/RegisterSurveyors`
        },
        {
          id: 3,
          name: "Register Admins",
          route: `/Main/${this.id}/RegisterAdmins`
        },
        {
          id: 4,
          name: "Configuration",
          route: `/Main/${this.id}/Configuration`
        },
        {
          id: 5,
          name: "Broadcast",
          route: `/Main/${this.id}/Broadcast`
        },
        {
          id: 6,
          name: "Resource",
          route: `/Main/${this.id}/Resource`
        }
      ]
    };
  }
};
</script>

<style scoped>
/*To Avoide the auto Captualization */
.v-tab {
  text-transform: none !important;
}
</style>